import api from '@/services/api';

export default {
  async updateWorksheetParameters(budgetIterationId, worksheetParameters, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        worksheetParameters: worksheetParameters,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.put('Worksheet/Parameters', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async updatePropertyWorksheetEntries(budgetIterationId, propertyWorksheetEntries, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        propertyWorksheetEntries: propertyWorksheetEntries,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('Worksheet/Property/Entries', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async updateUnitTypeWorksheetEntries(budgetIterationId, unitTypeWorksheetEntries, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        unitTypeWorksheetEntries: unitTypeWorksheetEntries,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('Worksheet/UnitType/Entries', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async updateUnitWorksheetEntries(budgetIterationId, unitWorksheetEntries, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        unitWorksheetEntries: unitWorksheetEntries,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('Worksheet/Unit/Entries', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async commentsExist(budgetIterationId, tabTypeId) {
    let response = await api.get(`Worksheet/${budgetIterationId}/CommentsExist/${tabTypeId}`);
    if (response && response.status == 200 && response.data) {
      return response.data;
    }
    let fakeresults = {
      unresolvedFlagExists: false,
      hasComments: false
    };
    return fakeresults;
  },
  async getComments(budgetIterationId, tabTypeId) {
    let response = await api.get(`Worksheet/${budgetIterationId}/Comments/${tabTypeId}`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async createComment(note, isFlag, repliesToNoteId, budgetIterationId, worksheetTabId) {
    let requestBody = {
      note: note,
      isFlag: isFlag,
      repliesToNoteId: repliesToNoteId,
      budgetIterationId: budgetIterationId,
      worksheetTabId: worksheetTabId
    };
    let response = await api.post('Worksheet/CreateComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async resolveComment(worksheetTabNoteId, note) {
    let requestBody = {
      worksheetTabNoteId: worksheetTabNoteId,
      note: note
    };
    let response = await api.post('Worksheet/ResolveComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async editComment(commentId, text) {
    let requestBody = {
      commentId: commentId,
      note: text
    };
    let response = await api.post('Worksheet/EditComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async deleteComment(commentId) {
    let requestBody = {
      commentId: commentId
    };
    let response = await api.post('Worksheet/DeleteComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
}
